import React from 'react'
import { IonText, IonGrid, IonRow } from '@ionic/react'
import strings from '../../../strings'

import './styles/loader.less'

const Loader: React.FC = () => (
	<IonGrid className="loader-container">
		<IonRow className="spinner-row">
			<i className="fal fa-spinner fa-spin" />
		</IonRow>
		<IonRow>
			<IonText aria-live="assertive">{strings.loading}</IonText>
		</IonRow>
	</IonGrid>
)

export default Loader
